import { PageHeader } from "@shared/components/PageHeader";
import { Tabs } from "@shared/ui/tabs";
import React from "react";
import { CreateReconnectionRequest } from "./create";
import BulkCreateReconnectionRequest from "./bulkReconnection/create";

const LandingReconnectRequest: React.FC = () => {
  const urlMapping = {
    singleRequest: "singleRequest",
    bulkRequest: "bulkRequest",
  };
  const tabComponents = {
    singleRequest: {
      label: "Single Request",
      component: <CreateReconnectionRequest />,
    },
    bulkRequest: {
      label: "Bulk Request",
      component: <BulkCreateReconnectionRequest />,
    },
  };
  return (
    <div>
      <div>
        <PageHeader
          title="Create Reconnection Request"
          subtitle="Complete the following steps to submit a reconnection request."
        />
      </div>
      <div className="mt-2 space-y-4">
        <Tabs
          defaultValue="singleRequest"
          className="w-full"
          tabsListClassName="inline-flex w-fit bg-gradient-to-r from-blue-100/50 to-indigo-100/50 shadow-sm"
          urlMapping={urlMapping}
          tabComponents={tabComponents}
          level={0} // Top-level tabs
        />
      </div>
    </div>
  );
};

export default LandingReconnectRequest;
